import { render, staticRenderFns } from "./copyCompany.vue?vue&type=template&id=6b622aee&"
import script from "./copyCompany.vue?vue&type=script&lang=js&"
export * from "./copyCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports